var _effectorFileName = "/src/page-content/individual-lessons/components/pluses-individual-lessons/pluses-individual-lessons.tsx";
import { useUnit } from 'effector-react';
import { useTranslation } from 'next-i18next';
import { INDIVIDUAL_PLUSES_LIST } from '@/page-content/individual-lessons/constants/pluses-list';
import { Article } from '@/shared/components/article';
import { CardCustom } from '@/shared/components/card-custom';
import { ContactForm } from '@/shared/components/contact-form';
import { $isContactFormSentSuccessfully, contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData } from '@/shared/components/contact-form/types';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
export const PlusesIndividualLessons = () => {
  const {
    t
  } = useTranslation('individual-lessons-pluses');
  const items = INDIVIDUAL_PLUSES_LIST.map(item => ({
    header: t(item.headerKey),
    text: t(item.textKey)
  }));
  const {
    isContactFormSentSuccessfully,
    onContactFormSend
  } = useUnit({
    onContactFormSend: contactFormDataSent,
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">{t('title')}</h2>

      <div className="grid grid-cols-1 items-center gap-y-6 md:gap-x-20 lg:grid-cols-[1fr_minmax(200px,_50%)] xl:grid-cols-[1fr_minmax(200px,_40%)]">
        <TextPlusesList items={items} />

        <CardCustom isCardDataSentSuccessfully={isContactFormSentSuccessfully}>
          <ContactForm entryPoint="INDIVIDUAL_PAGE" buttonText={t('form.buttonText')} onFormSubmit={handleContactFormSubmit} />
        </CardCustom>
      </div>
    </Article>;
};